/**
 * ImageSourceCards - Image source selector: Stock Photos vs AI Generated.
 * Uses SegmentedPicker for a consistent always-visible quick-tweak UX.
 */

import { Image, Sparkles } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';
import type { ImageSourceType } from '@/constants/imageSource';
import { SegmentedPicker } from '../../common/SegmentedPicker';
import type { SegmentOption } from '../../common/SegmentedPicker';

interface ImageSourceCardsProps {
  imageSource: ImageSourceType;
  onImageSourceChange: (source: ImageSourceType) => void;
  disabled: boolean;
}

export function ImageSourceCards({
  imageSource,
  onImageSourceChange,
  disabled,
}: ImageSourceCardsProps) {
  const { t } = useTranslation();

  const options: SegmentOption[] = [
    {
      value: 'stock',
      label: t('imageSource.stock.label'),
      description: t('imageSource.stock.description'),
      iconNode: <Image className="h-5 w-5" />,
      trailingMeta: t('imageSource.stock.pricing', { defaultValue: 'Free' }),
    },
    {
      value: 'ai',
      label: t('imageSource.ai.label'),
      description: t('imageSource.ai.description'),
      iconNode: <Sparkles className="h-5 w-5" />,
    },
  ];

  return (
    <SegmentedPicker
      options={options}
      value={imageSource}
      onChange={(val) => onImageSourceChange(val as ImageSourceType)}
      size="md"
      layout="equal"
      disabled={disabled}
    />
  );
}
